import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_HW } from "../data/presets";

const HardwareContext = createContext(null);
const KEY = "llmready_hardware";
const CMP = "llmready_compare";

export function HardwareProvider({ children }) {
  const [hardware, setHardwareState] = useState(() => {
    try {
      const s = localStorage.getItem(KEY);
      return s ? JSON.parse(s) : DEFAULT_HW;
    } catch {
      return DEFAULT_HW;
    }
  });
  const [compare, setCompare] = useState(() => {
    try {
      const s = localStorage.getItem(CMP);
      return s ? JSON.parse(s) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(hardware));
  }, [hardware]);
  useEffect(() => {
    localStorage.setItem(CMP, JSON.stringify(compare));
  }, [compare]);

  const value = useMemo(() => {
    const setHardware = (patch) => setHardwareState((h) => ({ ...h, ...patch }));
    const applyHardware = (hw) => setHardwareState({ ...DEFAULT_HW, ...hw });
    const toggleCompare = (id) =>
      setCompare((c) => (c.includes(id) ? c.filter((x) => x !== id) : c.length < 3 ? [...c, id] : c));
    return { hardware, setHardware, applyHardware, compare, toggleCompare, setCompare };
  }, [hardware, compare]);

  return <HardwareContext.Provider value={value}>{children}</HardwareContext.Provider>;
}

export const useHardware = () => useContext(HardwareContext);
